export const LARGER_DEVICE_IMAGES_TO_SHOW = 3;

export const PHOTO_GRID_STATE_KEY = 'PHOTO_GRID_STATE_KEY';
